<template>
  <div class="top-header">
    <nav-left-shopinfo></nav-left-shopinfo>
    <el-button size="medium" type="primary" class="tool-button" v-popover:toolbox>
      工具箱
    </el-button>
    <el-popover
      ref="toolbox"
      placement="bottom"
      width="864"
      trigger="hover"
      popper-class="status"
    >
      <div class="container">
        <div class="menu-list">
          <div
            class="menu-item"
            v-for="menu in menuList"
            v-if="menu.children.length >= 1"
          >
            <h4>{{ menu.name }}</h4>
            <div class="sub-menu-list">
              <div
                class="sub-menu-item"
                v-for="(submenu, subindex) in menu.children"
                @click="$router.push(submenu.path)"
              >
                <div
                  class="icon-box"
                  :style="{
                    background: colorClass[subindex % colorClass.length],
                  }"
                >
                  <img :src="submenu.icon" alt="" />
                </div>
                {{ submenu.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-popover>
    <el-badge :value="messageNum" :hidden="!messageNum" class="item">
      <i class="el-icon-message" @click="linkTo('/message')"></i>
    </el-badge>
    <el-button
      size="medium"
      :type="printStatus ? 'success' : 'danger'"
      plain
      v-popover:printstatus
    >
      {{ printStatus ? "开启打印" : "关闭打印" }}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <el-popover
      ref="printstatus"
      placement="bottom"
      width="160"
      trigger="hover"
      popper-class="status"
    >
      <div class="header">打印状态</div>
      <div class="container">
        <span class="status" :class="printStatus ? 'open' : 'close'">{{
          printStatus ? "已开启" : "已关闭"
        }}</span>
        <el-switch
          class="float-right"
          v-model="printStatus"
          active-color="#67c23a"
          inactive-color="#f57878"
          @change="modifyPrintStatus"
        ></el-switch>
      </div>
    </el-popover>
    <el-popover
      ref="acceptancestatus"
      placement="bottom"
      width="160"
      trigger="hover"
      popper-class="status"
    >
      <div class="header">接单状态</div>
      <div class="container">
        <span class="status" :class="acceptancestatus ? 'open' : 'close'">{{
          acceptancestatus ? "已开启" : "已关闭"
        }}</span>
        <span @click="toggleAcceptanceStatus">
          <el-switch
            class="float-right"
            v-model="acceptancestatus"
            active-color="#67c23a"
            inactive-color="#f57878"
            @change="modifyAcceptanceStatus"
            disabled
          ></el-switch>
        </span>
      </div>
    </el-popover>
    <el-button
      size="medium"
      :type="acceptancestatus ? 'success' : 'primary'"
      plain
      v-popover:acceptancestatus
    >
      {{ acceptancestatus ? "自动接单" : "手动接单" }}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <el-button
      size="medium"
      :type="shopStatus ? 'success' : 'danger'"
      plain
      v-popover:shopstatus
    >
      {{ shopStatus ? "正常运营" : "紧急关店" }}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <el-popover
      ref="shopstatus"
      placement="bottom"
      width="160"
      trigger="hover"
      popper-class="status"
    >
      <div class="header">店铺状态</div>
      <div class="container">
        <span class="status" :class="shopStatus ? 'open' : 'close'">{{
          shopStatus ? "已开启" : "已关闭"
        }}</span>
        <el-switch
          class="float-right"
          v-model="shopStatus"
          active-color="#67c23a"
          inactive-color="#f57878"
          @change="modifyShopStatus"
        ></el-switch>
      </div>
    </el-popover>
    <el-image class="avatar layout" :src="defaultAvatar" fit="fill" v-popover:userinfo>
      <div slot="error">
        <img class="avatar" src="@/assets/img/user/avatar.png" alt />
      </div>
      <div slot="placeholder">
        <img class="avatar" src="@/assets/img/user/avatar.png" alt />
      </div>
    </el-image>
    <el-popover
      ref="userinfo"
      placement="bottom"
      width="300"
      trigger="hover"
      popper-class="personal-center no-padding"
    >
      <div class="header">
        <div class="userinfo-container">
          <el-image class="avatar layout" :src="defaultAvatar" fit="fill">
            <div slot="error">
              <img class="avatar" src="@/assets/img/user/avatar.png" alt />
            </div>
            <div slot="placeholder">
              <img class="avatar" src="@/assets/img/user/avatar.png" alt />
            </div>
          </el-image>
          <div class="userinfo">
            <p class="nickname">{{ shop.shopName }}</p>
            <el-tag class="business-hours">{{ shop.businessHours }}</el-tag>
            <el-tag class="state" :type="shop.isVerified ? 'success' : 'danger'">{{
              shop.isVerified ? "已认证" : "未认证"
            }}</el-tag>
          </div>
        </div>
        <div class="user-options">
          <el-button
            v-if="shopIsMaster"
            size="mini"
            type="primary"
            @click="linkTo('/setting/account')"
            >修改密码</el-button
          >
          <el-button size="mini" type="primary" plain @click="loginOut"
            >退出登录</el-button
          >
        </div>
      </div>
      <div class="footer" v-show="isOwn">官方服务热线: 400-8080-858</div>
    </el-popover>
  </div>
</template>

<script>
import navLeftShopinfo from "@/components/navLeftShopinfo.vue";
import { mapState, mapActions } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";
import { setShopIsBusiness, toSetIsAutoTake, loginOut, getShopInfo } from "@/api";
import { menuListMixins } from "@/mixins/menuListMixins";

export default {
  mixins: [commonFuc, menuListMixins],
  data() {
    return {
      shopStatus: true,
      acceptancestatus: true,
      defaultAvatar: require("@/assets/img/user/avatar.png"),
      messageNum: 0,
      printStatus: localStorage.getItem("printStatus") == "false" ? false : true,
    };
  },
  components: {
    navLeftShopinfo,
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
      messageList: (state) => state.messageList,
      isOwn: (state) => state.isOwn,
    }),
  },
  watch: {
    messageList(val) {
      let num = 0;
      val.forEach((val) => {
        if (!val.isRead) {
          num++;
        }
      });
      this.messageNum = num;
    },
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    ...mapActions(["clearShopInfo"]),
    getPageData() {
      getShopInfo().then((res) => {
        this.shopStatus = res.data.isBusiness ? true : false;
        this.acceptancestatus = res.data.isAutoTake ? true : false;
      });
    },
    linkTo(path) {
      this.$router.push({
        path: path,
      });
    },
    modifyShopStatus() {
      if (!this.shopStatus) {
        this.$confirm("严重影响顾客体验，请谨慎操作", "紧急关店", {
          confirmButtonText: "确定关店",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.shopStatus = false;
            setShopIsBusiness({
              isBusiness: this.shopStatus ? 1 : 0,
            }).then((res) => {
              if (res.code == 1) {
                console.log(res);
              }
            });
          })
          .catch(() => {
            this.shopStatus = true;
          });
      } else {
        setShopIsBusiness({
          isBusiness: this.shopStatus ? 1 : 0,
        }).then((res) => {
          if (res.code == 1) {
            console.log(res);
          }
        });
      }
    },
    modifyAcceptanceStatus() {
      toSetIsAutoTake({
        isAutoTake: this.acceptancestatus ? 1 : 0,
      }).then((res) => {
        if (res.code == 1) {
          console.log(res);
        }
      });
    },
    loginOut() {
      loginOut().then((res) => {
        if (res.code == 1) {
          localStorage.removeItem("sessionId");
          localStorage.removeItem("userId");
          localStorage.removeItem("userType");
          localStorage.removeItem("shopStoreId");
          this.clearShopInfo({});
          this.$router.push({
            path: "/login",
          });
        }
      });
    },
    toggleAcceptanceStatus() {
      if (!this.acceptancestatus) {
        this.$confirm(`确认是否已经设置好打印机，否则无法自动接单。`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.acceptancestatus = true;
            this.modifyAcceptanceStatus();
          })
          .catch(() => {});
      } else {
        this.acceptancestatus = false;
        this.modifyAcceptanceStatus();
      }
    },
    modifyPrintStatus() {
      localStorage.setItem("printStatus", this.printStatus);
    },
  },
};
</script>

<style lang="less" scoped>
.top-header {
  display: flex;
  padding: 16px 0 15px;
  // float: right;
  // position: relative;
  z-index: 1;
  justify-content: flex-end;
  align-items: center;
  background: linear-gradient(
    134.24deg,
    rgba(255, 241, 240, 1) 0%,
    rgba(255, 250, 245, 1) 100%
  );
  .tool-button {
    margin-right: 7px;
  }
  .el-badge {
    margin-right: 15px;
    padding-right: 15px;
    border-right: 1px solid #eeeeee;
  }
  .el-icon-message {
    font-size: 28px;
    color: #409eff;
    cursor: pointer;
  }
  .avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    &.layout {
      margin: 0 20px 0 14px;
    }
  }
  .el-button {
    margin-left: 7px;
    .el-icon--right {
      margin-left: 0;
    }
  }
}
.status {
  .header {
    font-size: 12px;
    line-height: 14px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #eeeeee;
  }
  .container {
    margin-top: 13px;
    .status {
      font-size: 12px;
      &.open {
        color: #67c23a;
      }
      &.close {
        color: #f57878;
      }
    }
  }
}
.personal-center {
  .header {
    padding: 20px;
    .userinfo-container {
      display: flex;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 10px;
      .avatar {
        width: 40px;
        height: 40px;
        border-radius: 100%;
        margin-right: 10px;
      }
      .nickname {
        font-size: 14px;
        line-height: 14px;
        font-weight: bold;
      }
      .el-tag {
        height: 17px;
        line-height: 15px;
        padding: 0 4px;
        margin-top: 10px;
        &.business-hours {
          margin-right: 10px;
        }
      }
    }
    .user-options {
      margin-top: 10px;
      text-align: center;
      .el-button {
        padding: 9px 35px;
        & + .el-button {
          margin-left: 20px;
        }
      }
    }
  }
  .footer {
    font-size: 12px;
    line-height: 34px;
    color: #999999;
    background: #f5f5f6;
    padding-left: 20px;
  }
}
</style>

<style lang="less">
.top-header {
  .el-badge {
    .el-badge__content.is-fixed {
      top: 4px;
      right: 27px;
    }
  }
}
.container {
  .menu-list {
    max-height: 80vh;
    padding: 0 40px;
    overflow: auto;
    scroll-behavior: smooth;
    &::-webkit-scrollbar {
      display: block;
    }
    .menu-item {
      cursor: pointer;
      h4 {
        font-size: 14px;
        line-height: 21px;
        margin: 10px 0;
      }
      .sub-menu-list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        .sub-menu-item {
          margin-right: 12px;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding: 10px 18px;
          background-color: rgba(248, 248, 248, 1);
          border-radius: 3px;
          .icon-box {
            width: 18px;
            height: 18px;
            border-radius: 3px;
            margin-right: 6px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              height: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
